import React, { useState, useEffect } from 'react';
import UserStatus from './UserStatus';
import API from '../api';

const FAQItem = ({ question, answer }) => {
  return (
    <div className="faq-item" style={{ marginBottom: '20px' }}>
      <h4 style={{ fontWeight: 'bold' }}>{question}</h4>
      <p>{answer}</p>
    </div>
  );
};

const FAQPage = () => {
  const faqs = [
    {
      question: 'What is this service and how does it work?',
      answer:
        'Our platform is a subscription-based web app that sends SMS and telegram alerts when your selected stocks hit your target buy or sell prices or when its price rises or fall by a certain % in any day. You also receive timely news notifications for your selected stocks.',
    },
    {
      question: 'What types of alerts will I receive?',
      answer:
        'You’ll receive two main types of alerts: Price Alerts (when a stock reaches your target price or price rises/fall by your defined percentage), and News Alerts (when important news from verified sources is released about your selected stocks).',
    },
    {
      question: 'Which markets or stocks are supported?',
      answer:
        'We only support all stocks listed in Dhaka Stock Exchange.',
    },
    {
      question: 'How do I set up my alerts?',
      answer:
        'After Signing Up, you will have Log in to get access to the dashboard. You can search for a stock, set your desired buy/sell price levels, desired % change levels, choose your preferred notification channel (SMS or Telegram), and save your phone number.',
    },
    {
      question: 'How do I configure phone to receive notifications?',
      answer:
        'In your dashboard, enter your phone number and select options sms / telegram for price notifications. News notifications will by default only be sent to your telegram account. Link your telegram account to receive messages.',
    },
    {
      question: 'How do I receive notifications on Telegram?',
      answer:
        'After saving your phone number in dashboard, you will be shown a button. Click on it and go to your telegram account. This link will also be sent to your email on saving phone number.',
    },
    {
      question: 'What platforms are supported for notifications?',
      answer:
        'We currently support notifications via SMS and telegram. You can choose any one of the two for paid plans but free trial offers only telegram notifications.',
    },
    {
      question: 'Are notifications sent in real-time?',
      answer:
        'We process all alerts real-time. However, there can be some delay due to network dependencies and data availability',
    },
    {
      question: 'Do I need to install an app?',
      answer:
        'No app installation is required. The platform is fully web-based and accessible from all major browsers from desktop and mobile devices.',
    },
    {
      question: 'Can I cancel or change my alerts anytime?',
      answer:
        'Yes, you can modify or delete alerts anytime from your user dashboard.',
    },
    {
      question: 'How do the subscription plans work?',
      answer:
        'We offer multiple subscription tiers based on the number of stocks and features. You can pay monthly, 3 months, 6 months or annually.',
    },
    {
      question: 'Is there a free trial available?',
      answer:
        'Yes, we offer a free trial so you can explore before subscribing.',
    },
    {
      question: 'How secure is my data?',
      answer:
        'We use industry-standard encryption and follow best practices to keep your personal and financial data safe.',
    },
    {
      question: 'What payment methods are accepted?',
      answer:
        'We accept major credit/debit cards and MFS like BKASH and Nagad',
    },
    {
      question: 'Can I upgrade or downgrade my subscription?',
      answer:
        'Yes, you can change your plan anytime in your account settings. Upgrades are applied immediately and will cancel any existing plan you are on; For downgrades, you need to wait until your current subscription expires',
    },
    {
      question: 'Will I get charged for SMS or telegram messages?',
      answer:
        'No, all notification costs are included in your subscription. You will not be charged separately.',
    },
    {
      question: 'How do I contact support?',
      answer:
        'You can reach us via our support form, or email us at support@tradebarta.com.',
    },
  ];

useEffect(() => {
  document.title = "FAQ | TradeBarta.com";
}, []);


  return (
    <div>
      {/* Navbar Section */}
      <section className="navbar-area navbar-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav className="navbar navbar-expand-lg">
                <a className="navbar-brand" href="/">
                  <img width="200" height="70" src={require('../images/logo.png')} alt="Logo" />
                </a>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarOne"
                  aria-controls="navbarOne"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
                  <ul className="navbar-nav m-auto">
                    <li className="nav-item">
                      <a className="page-scroll" href="/">
                        Home
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="page-scroll" href="/pricing">
                        Pricing
                      </a>
                    </li>
                    
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                    <li className="nav-item">
                      <a className="active page-scroll" href="/faq">
                        FAQ
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="page-scroll" href="/contact">
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="navbar-btn">
                  <UserStatus />
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
<div
  className="form-container"
  style={{
    maxWidth: '800px',
    margin: '0 auto',
    textAlign: 'left',
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)'
  }}
>
  <h1 style={{marginTop: '120px', marginBottom: '40px', textAlign: 'center' }}>
    Frequently Asked Questions
  </h1>
  {faqs.map((faq, index) => (
    <FAQItem key={index} {...faq} />
  ))}
</div>                

<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>
      </div>
  );
};

export default FAQPage;
